import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Typography, Stack, Grid, Select, MenuItem } from "@mui/material";
import { Add } from "@mui/icons-material";
import { NavigateBefore, AccountCircle } from "@mui/icons-material";
import { ReactComponent as IconSecurity } from "../../images/iconSecurityNegado.svg";
import { ReactComponent as IconDiamond } from "../../images/icon-diamond.svg";

import CardPaciente from "../../components/CardPaciente";

import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { verificaPermissaoDeAcesso } from "../../services/permissoesDeAcesso";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import { getItemDecrypt } from "../../utils/cryptoData";

export default function DadosPaciente() {
  const navigate = useNavigate();
  const [duracaoAcesso, setDuracaoAcesso] = useState(0);
  const [justificativa, setJustificativa] = useState("");
  const [solicitado, setSolicitado] = useState("");
  const [count, setCount] = useState(0);
  const [usuarioAtivo, setUsuarioAtivo] = useState({});

  const vinculo = getItemDecrypt("vinculo_ativo");
  const usuario = getItemDecrypt("usuario");

  useEffect(() => {
    handlePermissaoDeAcesso();

    setUsuarioAtivo({
      nome: usuario.no_nome_usuario,
      vinculo: vinculo.perfil.nome,
    });

    handleAguardandoAutorizacao();
  }, []);

  const handlePermissaoDeAcesso = async () => {
    let vinculoPossuiPermissaoAcesso = await verificaPermissaoDeAcesso(
      id,
      vinculo.id
    );
    if (vinculoPossuiPermissaoAcesso) {
      navigate(`/pacientes/prontuario/${id}`);
    }
  };

  const handleAguardandoAutorizacao = async () => {
    try {
      const { data } = await api.post("/aguardando-autorizacao/", {
        data: {
          id_vinculo_solicitante: vinculo.id,
          id_paciente: id,
        },
      });

      setSolicitado(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  useEffect(() => {
    setCount(justificativa.length);
  }, [justificativa]);

  async function Solicitar() {
    if (justificativa.length > 0 && duracaoAcesso > 0) {
      try {
        const { response } = await api.post("/permissao-acesso/", {
          data: {
            id_vinculo_solicitante: vinculo.id,
            id_paciente: id,
            justification: justificativa,
            duration: duracaoAcesso,
          },
        });
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }

      setSolicitado(true);
    }
  }

  const { id } = useParams();

  const styles = {
    title: {
      fontWeight: "300",
      fontSize: "1.5rem",
      lineHeight: "25px",
      color: "#063F5E",
      textAlign: "center",
      lineHeight: "2.5rem",
    },
    subtitle: {
      fontWeight: "300",
      fontSize: "1.2rem",
      lineHeight: "25px",
      marginBottom: "5px",
      marginTop: "10px",
      color: "#1E729F",
    },
    diamond: {
      fill: "#1E729F",
    },
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", zoom: "80%" }}>
      <Box>
        <ButtonGoBack />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box style={styles.title}>Prontuário do paciente</Box>
          <Button variant="contained" endIcon={<Add />} disabled>
            Iniciar consulta
          </Button>
        </Box>

        <CardPaciente id={id} />

        <Box sx={{ p: "0 5rem" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0px 0px 5px 4px rgba(217,217,217,0.3)",
              p: "1rem",
            }}
          >
            <IconSecurity width="2rem" />
            {solicitado ? (
              <Typography style={styles.title}>
                Solicitação de acesso em análise
              </Typography>
            ) : (
              <Typography style={styles.title}>
                Para ter acesso aos dados do paciente,<br></br> solicite acesso
                abaixo:
              </Typography>
            )}
            {solicitado ? (
              <Typography sx={{ color: "#1E729F", textAlign: "center", mt: 2 }}>
                Sua solicitação de acesso aos dados do paciente está sendo
                analisada. <br /> Para mais informações, acesse à página de
                ajuda ou entre em contato conosco
              </Typography>
            ) : (
              <></>
            )}
            {solicitado ? (
              <></>
            ) : (
              <>
                <Stack>
                  <Typography style={styles.subtitle}>Vinculo</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <AccountCircle fontSize="large" />
                    <Stack>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {usuarioAtivo?.nome}
                      </Typography>
                      <Typography>{usuarioAtivo?.vinculo}</Typography>
                    </Stack>
                  </Box>
                  <Stack spacing={1}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      sx={{ color: "#1E729F", fontWeight: "bold" }}
                    >
                      Duração de acesso <IconDiamond fill="#FC8518" />
                    </Grid>
                    <Select
                      required
                      style={{
                        width: 300,
                        border: "1px solid #1E729F",
                        borderRadius: 10,
                      }}
                      value={duracaoAcesso}
                      onChange={(event) => {
                        setDuracaoAcesso(event.target.value);
                      }}
                    >
                      <MenuItem value={0} disabled>
                        Selecione
                      </MenuItem>
                      <MenuItem value={1}>1 hora</MenuItem>
                      <MenuItem value={2}>1 dia</MenuItem>
                      <MenuItem value={3}>1 semana</MenuItem>
                      <MenuItem value={4}>Sempre</MenuItem>
                    </Select>
                  </Stack>
                </Stack>

                <Stack
                  spacing={1}
                  sx={{ mt: 3, display: "flex", flexDirection: "column" }}
                >
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    sx={{ color: "#1E729F", fontWeight: "bold" }}
                  >
                    Justificativa <IconDiamond fill="#FC8518" />
                  </Grid>
                  <textarea
                    style={{
                      width: 300,
                      height: "5rem",
                      border: "1px solid #1E729F",
                      borderRadius: 10,
                      padding: 10,
                      resize: "vertical",
                    }}
                    variant="outlined"
                    placeholder="Descreva a justificativa"
                    value={justificativa}
                    onChange={(event) => {
                      setJustificativa(event.target.value);
                    }}
                  />
                  <Typography style={styles.subtitle}>{count}/250</Typography>

                  <Button
                    sx={{
                      width: 130,
                      textTransform: "none",
                      fontSize: "1.2rem",
                      alignSelf: "end",
                    }}
                    variant="contained"
                    onClick={() => Solicitar()}
                  >
                    Solicitar
                  </Button>
                </Stack>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
